import { useParams } from 'react-router-dom';

import { getTeamsSyncSettingsRequest, updateTeamsSyncSettingsRequest } from '@vyce/core/src/api/teams';
import { getPaySchedulesRequest } from '@vyce/core/src/api/pay';
import { getSitesRequest } from '@vyce/core/src/api/time';
import { getUrlItems } from '@vyce/core/src/utils/url';

import { useTypedSelector } from '../../../hooks';

export const useTeamSettingsData = () => {
  const { team } = useParams<{ team: string }>();
  const { selectedCompany } = useTypedSelector(state => state.helper);

  const teamUrlItems = getUrlItems(team);

  return {
    teamId: teamUrlItems?.id,
    selectedCompanyId: selectedCompany?.uuid ?? '',
    updateTeamsSyncSettingsRequest,
    getTeamsSyncSettingsRequest,
    getPaySchedulesRequest,
    getSitesRequest,
  };
};
